import Footer from "./small/Footer";
import { Icon } from "@iconify/react";
import { useState } from "react";
import TopRaffles from "./small/topRaffles";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

const AccountPage = () => {
  const percentage1 = 70;
  const percentage2 = 80;
  const tabPhysicalproducts = [
    {
      firstImg: "../../../assets/images/tabsImages/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "qasim ",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img5.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img7.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img8.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];

  const tabPhysicalproductsRaffleswon = [
    {
      firstImg: "../../../assets/images/tabsImages/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "qasim ",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/tabsImages/img4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];

  const topRaffles = [
    {
      firstImg: "../../../assets/images/topraffle/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main5.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main7.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main8.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];

  const topRafflesRaffleswon = [
    {
      firstImg: "../../../assets/images/topraffle/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];

  const [profileTitle, setProfileTitle] = useState("Nick Henry");
  const [width, setWidth] = useState(10);

  const changeHandler = (e) => {
    // console.log(e);
    setWidth(e.target.value.length);
    setProfileTitle(e.target.value);
  };

  return (
    <>
      <section className="topaccountpage">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-sm-8">
              <div className="row">
                <div className="col-sm-4">
                  <img
                    className="profile-image"
                    src="../../assets/images/accountpage/prof-img.png"
                    alt=""
                  />
                </div>
                <div className="col-sm-8">
                  <div className="prof-title-wrap">
                    <label>
                      <input
                        type="text"
                        className="profile-title"
                        value={profileTitle}
                        onChange={(e) => changeHandler(e)}
                        style={{ width: width + "ch" }}
                      />
                      <Icon icon="ci:edit" />
                    </label>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div className="deails-single-wrap">
                        <h3 className="detail-single-tit">Physical Items</h3>
                        <h3 className="detail-single-value">500</h3>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="deails-single-wrap">
                        <h3 className="detail-single-tit">Physical Items</h3>
                        <h3 className="detail-single-value">500</h3>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="deails-single-wrap">
                        <h3 className="detail-single-tit">Physical Items</h3>
                        <h3 className="detail-single-value">500</h3>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="deails-single-wrap">
                        <h3 className="detail-single-tit">Physical Items</h3>
                        <h3 className="detail-single-value">500</h3>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="deails-single-wrap">
                        <h3 className="detail-single-tit">Physical Items</h3>
                        <h3 className="detail-single-value">500</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-sm-4 text-end align-items">
              <div className="editcover-btn-wrapp">
                <button className="editcover-btn">
                  <Icon icon="entypo:camera" /> Edit Cover Photo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <main className="account-bg">
        {/* tabs stars here         */}

        <section className="tab-product">
          <div className="row">
            <div className="col-md-12">
              <div className="tabs-buttons">
                <div className="container">
                  <ul
                    class="nav nav-pills mb-3  bb  "
                    id="pills-tab"
                    role="tablist"
                  >
                    <div className="left-tab d-flex ">
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link active product-tab market-product-tab"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          <Icon
                            icon="bi:shop"
                            height={18}
                            color="white"
                            className="icon"
                          />
                          <p>Shop</p>
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link market-product-tab"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          <div className="product-tab">
                            <Icon
                              icon="carbon:money"
                              height={18}
                              color="white"
                            />
                            <p>Raffles Won</p>
                          </div>
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link market-product-tab"
                          id="pills-contact-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-contact"
                          type="button"
                          role="tab"
                          aria-controls="pills-contact"
                          aria-selected="false"
                        >
                          <div className="product-tab">
                            <Icon icon="ph:stack" height={18} color="white" />
                            <p>Auction Won</p>
                          </div>
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link market-product-tab"
                          id="pills-disabled-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-disabled"
                          type="button"
                          role="tab"
                          aria-controls="pills-disabled"
                          aria-selected="false"
                        >
                          <div className="product-tab">
                            <Icon
                              icon="fluent:history-32-filled"
                              height={18}
                              color="white"
                            />
                            <p>Order History & Status</p>
                          </div>
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link market-product-tab"
                          id="pills-balancetab"
                          data-bs-toggle="pill"
                          data-bs-target="#balancetab"
                          type="button"
                          role="tab"
                          aria-controls="balancetab"
                          aria-selected="false"
                        >
                          <div className="product-tab">
                            <Icon
                              icon="ic:round-account-balance-wallet"
                              height={18}
                              color="white"
                            />
                            <p>Balance</p>
                          </div>
                        </button>
                      </li>
                    </div>

                    <div className="right-tab d-flex ">
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link market-product-tab"
                          id="pills-disabled-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-disabled"
                          type="button"
                          role="tab"
                          aria-controls="pills-disabled"
                          aria-selected="false"
                          disabled
                        >
                          <div className="product-tab listed">
                            <p>Recent Listed</p>
                            <Icon
                              icon="ep:arrow-up-bold"
                              rotate={2}
                              height={16}
                              color="white"
                            />
                          </div>
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link market-product-tab"
                          id="pills-disabled-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-disabled"
                          type="button"
                          role="tab"
                          aria-controls="pills-disabled"
                          aria-selected="false"
                          disabled
                        >
                          <div className="product-tab">
                            <img src="\image\grid-icon.svg" alt="" />
                          </div>
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link market-product-tab"
                          id="pills-disabled-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-disabled"
                          type="button"
                          role="tab"
                          aria-controls="pills-disabled"
                          aria-selected="false"
                          disabled
                        >
                          <div className="product-tabs">
                            <img src="\image\grid-foundation-icon.svg" alt="" />
                          </div>
                        </button>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
              <hr />
              <div className="tabs-buttons">
                <div className="container">
                  <div className="refresher">
                    <div className="reff d-flex align-items-center">
                      <div className="refreshBtn">
                        <Icon
                          icon="eos-icons:arrow-rotate"
                          height={32}
                          color="white"
                        />
                      </div>
                      <p>Refreshed A While Ago</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              {/* Tab Content */}

              <div class="tab-content" id="pills-tabContent">
                {/* tab1 */}
                <div
                  class="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                  tabindex="0"
                >
                  <div className="container">
                    <div className="row">
                      <h1 className="project-tab-title">
                        List Of Physical Items{" "}
                      </h1>
                      <TopRaffles
                        ArrayS={tabPhysicalproducts}
                        buttontext="Owned"
                      />
                    </div>
                  </div>
                  <div className="container">
                    <div className="border-between"></div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <h1 className="project-tab-title title2">
                        Physical Items
                      </h1>
                      <TopRaffles ArrayS={topRaffles} buttontext="Owned" />
                    </div>
                  </div>
                </div>

                {/* tab2 */}
                <div
                  class="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                  tabindex="0"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-6">
                        <h1 className="project-tab-title">Digital Items</h1>
                      </div>

                      <div className="col-sm-6">
                        <div className="seeall-wrap">
                          <a className="seelist" href="#">
                            See All List{" "}
                          </a>
                        </div>
                      </div>
                      <TopRaffles
                        ArrayS={tabPhysicalproductsRaffleswon}
                        buttontext="Owned"
                      />
                    </div>
                  </div>
                  <div className="container">
                    <div className="border-between"></div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <h1 className="project-tab-title title2">
                        List Of Digital Items
                      </h1>
                      <TopRaffles
                        ArrayS={topRafflesRaffleswon}
                        buttontext="Owned"
                      />
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="border-upper"></div>
                      </div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="title">
                          <h2 className="main-tite nft-details-more-collection raflleswonlist">
                            <span> &#91;</span>Raffles Won List
                            <span> &#93;</span>
                          </h2>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="raffles-won-wrapp">
                          <table className="raffles-won">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Collection</th>
                                <th>Item</th>
                                <th>Winner</th>
                                <th>Time</th>
                                <th>Day</th>
                                <th>Actual Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <h3 className="type-tit">Physical</h3>
                                </td>
                                <td>
                                  <img
                                    src="../../assets/images/physicalproduct/moon.png"
                                    alt=""
                                  />
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <img
                                      className="profile-image-table"
                                      src="../../assets/images/accountpage/prof-img.png"
                                      alt=""
                                    />
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">07:40:60</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">Monday</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">2.5 SLP</h6>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <h3 className="type-tit">Physical</h3>
                                </td>
                                <td>
                                  <img
                                    src="../../assets/images/physicalproduct/moon.png"
                                    alt=""
                                  />
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <img
                                      className="profile-image-table"
                                      src="../../assets/images/accountpage/prof-img.png"
                                      alt=""
                                    />
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">07:40:60</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">Monday</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">2.5 SLP</h6>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <h3 className="type-tit">Physical</h3>
                                </td>
                                <td>
                                  <img
                                    src="../../assets/images/physicalproduct/moon.png"
                                    alt=""
                                  />
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <img
                                      className="profile-image-table"
                                      src="../../assets/images/accountpage/prof-img.png"
                                      alt=""
                                    />
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">07:40:60</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">Monday</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">2.5 SLP</h6>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* tab 3 */}
                <div
                  class="tab-pane fade"
                  id="pills-contact"
                  role="tabpanel"
                  aria-labelledby="pills-contact-tab"
                  tabindex="0"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-6">
                        <h1 className="project-tab-title">Digital Items</h1>
                      </div>

                      <div className="col-sm-6">
                        <div className="seeall-wrap">
                          <a className="seelist" href="#">
                            See All List{" "}
                          </a>
                        </div>
                      </div>
                      <TopRaffles
                        ArrayS={tabPhysicalproductsRaffleswon}
                        buttontext="Owned"
                      />
                    </div>
                  </div>
                  <div className="container">
                    <div className="border-between"></div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <h1 className="project-tab-title title2">
                        List Of Digital Items
                      </h1>
                      <TopRaffles
                        ArrayS={topRafflesRaffleswon}
                        buttontext="Owned"
                      />
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="border-upper"></div>
                      </div>
                    </div>
                  </div>
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="title">
                          <h2 className="main-tite nft-details-more-collection raflleswonlist">
                            <span> &#91;</span>Auction Won List
                            <span> &#93;</span>
                          </h2>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="raffles-won-wrapp auction-won-list">
                          <table className="raffles-won">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Collection</th>
                                <th>Item</th>
                                <th>Winner</th>
                                <th>Time</th>
                                <th>Day</th>
                                <th>Actual Price</th>
                                <th>Auction Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <h3 className="type-tit">Physical</h3>
                                </td>
                                <td>
                                  <img
                                    src="../../assets/images/physicalproduct/moon.png"
                                    alt=""
                                  />
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <img
                                      className="profile-image-table"
                                      src="../../assets/images/accountpage/prof-img.png"
                                      alt=""
                                    />
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">07:40:60</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">Monday</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">2.5 SLP</h6>
                                </td>
                                <td>
                                  <div className="auction-price">
                                    <span className="slp">SLP</span>
                                    <span className="price-acc">650</span>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h3 className="type-tit">Physical</h3>
                                </td>
                                <td>
                                  <img
                                    src="../../assets/images/physicalproduct/moon.png"
                                    alt=""
                                  />
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <img
                                      className="profile-image-table"
                                      src="../../assets/images/accountpage/prof-img.png"
                                      alt=""
                                    />
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">07:40:60</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">Monday</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">2.5 SLP</h6>
                                </td>
                                <td>
                                  <div className="auction-price">
                                    <span className="slp">SLP</span>
                                    <span className="price-acc">650</span>
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <h3 className="type-tit">Physical</h3>
                                </td>
                                <td>
                                  <img
                                    src="../../assets/images/physicalproduct/moon.png"
                                    alt=""
                                  />
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <img
                                      className="profile-image-table"
                                      src="../../assets/images/accountpage/prof-img.png"
                                      alt=""
                                    />
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">07:40:60</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">Monday</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">2.5 SLP</h6>
                                </td>
                                <td>
                                  <div className="auction-price">
                                    <span className="slp">SLP</span>
                                    <span className="price-acc">650</span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* tab 4 */}

                <div
                  class="tab-pane fade"
                  id="pills-disabled"
                  role="tabpanel"
                  aria-labelledby="pills-disabled-tab"
                  tabindex="0"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="title">
                          <h2 className="main-tite nft-details-more-collection raflleswonlist">
                            <span> &#91;</span>History and Status
                            <span> &#93;</span>
                          </h2>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="raffles-won-wrapp history">
                          <table className="raffles-won">
                            <thead>
                              <tr>
                                <th>Id</th>
                                <th>Type</th>
                                <th>Item</th>
                                <th>Name</th>
                                <th>Payment Method</th>
                                <th>Time Remaining</th>
                                <th>Status</th>
                                <th>Total</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <h3
                                    className="item-tit"
                                    style={{ paddingLeft: "30px" }}
                                  >
                                    #5906
                                  </h3>
                                </td>
                                <td>
                                  <h3 className="second-type">Physical</h3>
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">Credit Card</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">
                                    <div className="time-remaining">
                                      <Icon icon="bi:clock-history" /> 1 hr 26
                                      min
                                    </div>
                                  </h6>
                                </td>
                                <td>
                                  <h6 className="item-tit delivered">
                                    Delivered
                                  </h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">100 USD</h6>
                                </td>

                                <td>
                                  <Icon
                                    className="delete-icon"
                                    icon="ant-design:delete-filled"
                                  />
                                </td>
                              </tr>
                              <tr class="spacer-table-row"></tr>
                              <tr>
                                <td>
                                  <h3
                                    className="item-tit"
                                    style={{ paddingLeft: "30px" }}
                                  >
                                    #5906
                                  </h3>
                                </td>
                                <td>
                                  <h3 className="second-type digital">
                                    Digital
                                  </h3>
                                </td>

                                <td>
                                  <div className="itemwrapp">
                                    <h5 className="item-tit">
                                      “ Moon Rabbits t-shirt “
                                    </h5>
                                    <div className="owned-by">
                                      <img
                                        src="../../assets/images/accountpage/prof.png"
                                        alt=""
                                      />

                                      <div>
                                        <h4 className="owned-by">Owned By</h4>
                                        <h4 className="owned-by-val">
                                          Moon Rabbits
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <div className="winner-wrap">
                                    <h5 className="item-tit">jOE WILL</h5>
                                  </div>
                                </td>

                                <td>
                                  <h6 className="item-tit">Credit Card</h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">
                                    <div className="time-remaining">
                                      <Icon icon="bi:clock-history" /> 1 hr 26
                                      min
                                    </div>
                                  </h6>
                                </td>
                                <td>
                                  <h6 className="item-tit cancelled ">
                                    Cancelled
                                  </h6>
                                </td>
                                <td>
                                  <h6 className="item-tit">100 USD</h6>
                                </td>

                                <td>
                                  <Icon
                                    className="delete-icon"
                                    icon="ant-design:delete-filled"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* tab 5 */}
                <div
                  class="tab-pane fade"
                  id="balancetab"
                  role="tabpanel"
                  aria-labelledby="pills-balancetab"
                  tabindex="0"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="title">
                          <h2 className="main-tite nft-details-more-collection raflleswonlist">
                            <span> &#91;</span>Balance
                            <span> &#93;</span>
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className="balance-details-wrapp">
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="single-balance-wrap">
                            <div className="profile-balance-wrap">
                              <img
                                className="profile-image balance"
                                src="../../assets/images/accountpage/prof-img.png"
                                alt=""
                              />

                              <div>
                                <h3 className="balance-tit">Joe Will</h3>
                                <h6 className="bal-second-tit">
                                  Account person
                                </h6>

                                <h3 className="balance-tit">From</h3>
                                <h6 className="bal-second-tit">
                                  USA, New York
                                </h6>
                              </div>
                            </div>

                            <h3 className="consumption-tit">
                              Your Consumption Record
                            </h3>

                            <div className="progress-wrapp">
                              <div className="fordlexing">
                                <h3 className="physical-item-purchase">
                                  Physical Item Purchase
                                </h3>

                                <Icon icon="emojione:t-shirt" />
                              </div>

                              <div className="another-flexing">
                                <div className="first-coll-bal">
                                  <h3 className="balance-third-tit">
                                    Amount Spend : 500 USD
                                  </h3>
                                  <div className="perc">
                                    <Icon icon="bi:caret-up-fill" />{" "}
                                    <span>5.65%</span>
                                  </div>
                                  <h3 className="balance-third-tit">
                                    Compared To June
                                  </h3>
                                </div>

                                <div className="second-coll-bal">
                                  <CircularProgressbar
                                    value={percentage1}
                                    text={`${percentage1}%`}
                                    styles={buildStyles({
                                      // Rotation of path and trail, in number of turns (0-1)
                                      rotation: 0.25,

                                      // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                      strokeLinecap: "butt",

                                      // Text size
                                      textSize: "16px",

                                      // How long animation takes to go from one percentage to another, in seconds
                                      pathTransitionDuration: 0.5,

                                      // Can specify path transition in more detail, or remove it entirely
                                      // pathTransition: 'none',

                                      // Colors
                                      pathColor: `rgba(223, 197, 0, ${
                                        percentage1 / 100
                                      })`,
                                      textColor: "#fff",
                                      trailColor: "#d6d6d6",
                                      backgroundColor: "#3e98c7",
                                    })}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-6 ">
                          <h3 className="balance-tit text-xl-center digital-tit">
                            Digital Account
                          </h3>
                          <div className="forbtn-flex">
                            <button className="wallet-connected">
                              Wallet Connected
                            </button>

                            <button className="wallet-connected tokenslp">
                              Token : SLP
                            </button>
                          </div>
                          <h3 className="consumption-tit">
                            Your Consumption Record
                          </h3>

                          <div className="progress-wrapp">
                            <div className="fordlexing">
                              <h3 className="physical-item-purchase">
                                Physical Item Purchase
                              </h3>

                              <h3 className="balance-tit pe-5">NFT's</h3>
                            </div>

                            <div className="another-flexing">
                              <div className="first-coll-bal">
                                <h3 className="balance-third-tit">
                                  Amount Spend : 500 USD
                                </h3>
                                <div className="perc">
                                  <Icon icon="bi:caret-up-fill" />{" "}
                                  <span>5.65%</span>
                                </div>
                                <h3 className="balance-third-tit">
                                  Compared To June
                                </h3>
                              </div>

                              <div className="second-coll-bal">
                                <CircularProgressbar
                                  value={percentage2}
                                  text={`${percentage2}%`}
                                  styles={buildStyles({
                                    // Rotation of path and trail, in number of turns (0-1)
                                    rotation: 0.25,

                                    // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                    strokeLinecap: "butt",

                                    // Text size
                                    textSize: "16px",

                                    // How long animation takes to go from one percentage to another, in seconds
                                    pathTransitionDuration: 0.5,

                                    // Can specify path transition in more detail, or remove it entirely
                                    // pathTransition: 'none',

                                    // Colors
                                    pathColor: `rgba(223, 197, 0, ${
                                      percentage2 / 100
                                    })`,
                                    textColor: "#fff",
                                    trailColor: "#d6d6d6",
                                    backgroundColor: "#3e98c7",
                                  })}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
};
export default AccountPage;
